import {
  collection,
} from 'common/store/actions';

export const NAMESPACE = 'DEVICE/REGISTERS';

const collectionActions = collection.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  CLEAR,
} = collectionActions.TYPES;

export const {
  loadSuccess,
  loadError,
  clear,
} = collectionActions;

export const SELECT_PROFILE = 'DEVICE/ON_DEMAND_SAMPLING/SELECT_PROFILE';
export const ON_DEMAND_SAMPLING_CLOSE = 'DEVICE/ON_DEMAND_SAMPLING/CLOSE';
export const ON_DEMAND_SAMPLING_DOWNLOAD = 'DEVICE/ON_DEMAND_SAMPLING/DOWNLOAD';
export const ON_DEMAND_SAMPLING_DOWNLOAD_SUCCESS = 'DEVICE/ON_DEMAND_SAMPLING/DOWNLOAD_SUCCESS';
export const ON_DEMAND_SAMPLING_CLEAR_DATA = 'DEVICE/ON_DEMAND_SAMPLING/CLEAR_DATA';
export const ON_DEMAND_SAMPLING_IMMEDIATE_SAMPLES_CLOSE = 'DEVICE/ON_DEMAND_SAMPLING_IMMEDIATE_SAMPLES/CLOSE';

export const load = ({ deviceId, registers }) => ({
  ...collectionActions.load(),
  deviceId,
  registers,
});

export const selectMeteringProfile = meteringProfileId => ({
  type: SELECT_PROFILE,
  meteringProfileId,
});

export const onDemandSamplingClose = () => ({
  type: ON_DEMAND_SAMPLING_CLOSE,
});

export const onDemandSamplingExport = (exportOdrType) => ({
  type: ON_DEMAND_SAMPLING_DOWNLOAD,
  exportOdrType
});

export const onDemandSamplingExportSuccess = () => ({
  type: ON_DEMAND_SAMPLING_DOWNLOAD_SUCCESS,
});

export const clearImmediateSamplesData = () => ({
  type: ON_DEMAND_SAMPLING_CLEAR_DATA,
});

export const onDemandSamplingImmediateSamplesClose = () => ({
  type: ON_DEMAND_SAMPLING_IMMEDIATE_SAMPLES_CLOSE,
});
